import { gql } from 'apollo-boost';

export const GET_ADMIN_DATA_EXPORTS = gql`
    query GetAdminDataExports($data: GetAdminDataExportsInput) {
        getAdminDataExports(data: $data) {
            total
            stats {
                total
                pending
                processing
                completed
                failed
                declined
                cancelled
            }
            jobs {
                id
                owner {
                    id
                    email
                    fullName
                }
                scope
                canRegenerate
                status
                options {
                    exportType
                    includeNotes
                    includeFiles
                    includeImages
                    includeVideos
                    includeAudio
                    includeLinks
                }
                resultUrl
                expiresAt
                error
                attempts
                startedAt
                completedAt
                declinedAt
                declinedReason
                cancelledAt
                createdAt
                updatedAt
            }
        }
    }
`;
